import { useMemo } from 'react';
import useSWR from 'swr';

const PERMISSIONS = ['event_calendar.event.create', 'event_calendar.event.delete', 'event_calendar.event.update'];

/**
 * The three event rights of one club in a single request.
 *
 * SWR rather than `useCheckPermissions`, so every card of a calendar shares one
 * cached answer instead of asking once per card. Unknown rights read as denied,
 * which keeps buttons from flashing up and vanishing again while loading.
 */
export const useEventPermissions = (clubSlug?: string | null, enabled = true) => {
    const { data, isLoading } = useSWR<{ data: Record<string, boolean> }>(
        enabled && clubSlug ? [`clubs/${clubSlug}/permissions`, { permissions: PERMISSIONS }] : null,
        { revalidateOnFocus: false }
    );

    return useMemo(
        () => ({
            canCreate: !!data?.data?.['event_calendar.event.create'],
            canUpdate: !!data?.data?.['event_calendar.event.update'],
            canDelete: !!data?.data?.['event_calendar.event.delete'],
            isLoading
        }),
        [data, isLoading]
    );
};

export default useEventPermissions;
